import createAction from 'redux-actions/es/createAction';

export const showNotificationInfo = createAction('SHOW_NOTIFICATION_INFO');
export const showNotificationError = createAction('SHOW_NOTIFICATION_ERROR');
export const showNotificationDocument = createAction('SHOW_NOTIFICATION_DOCUMENT');

export const addNotification = createAction('ADD_NOTIFICATION');
export const removeNotification = createAction('REMOVE_NOTIFICATION');
